export default __webpack_public_path__ + "static/media/preset_cross_process.3fef8e74.jpg";